import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=d97c6910&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=d97c6910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97c6910",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d97c6910')) {
      api.createRecord('d97c6910', component.options)
    } else {
      api.reload('d97c6910', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=d97c6910&scoped=true&", function () {
      api.rerender('d97c6910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25DDahK1afNj0/JS/comp/DateRangeExt.vue"
export default component.exports